export var JSErrorsAggregationTypes;
(function (JSErrorsAggregationTypes) {
    JSErrorsAggregationTypes["errors"] = "ERROR";
    JSErrorsAggregationTypes["urls"] = "URL";
    JSErrorsAggregationTypes["screens"] = "SCREEN";
    JSErrorsAggregationTypes["pages"] = "PAGES";
    JSErrorsAggregationTypes["browsers"] = "BROWSER";
    JSErrorsAggregationTypes["os"] = "OS";
    JSErrorsAggregationTypes["devices"] = "DEVICE";
    JSErrorsAggregationTypes["countries"] = "COUNTRY";
})(JSErrorsAggregationTypes || (JSErrorsAggregationTypes = {}));
export var JSErrorsMetricNames;
(function (JSErrorsMetricNames) {
    JSErrorsMetricNames["Name"] = "name";
    JSErrorsMetricNames["AllVisits"] = "all-visits";
    JSErrorsMetricNames["VisitsWithErrors"] = "visits-with-errors";
    JSErrorsMetricNames["LostConversion"] = "lost-conversion";
    JSErrorsMetricNames["LostConversionSum"] = "lost-conversion-sum";
    JSErrorsMetricNames["ImpactOnGoal"] = "impact-on-goal";
    JSErrorsMetricNames["MissedOpportunity"] = "missed-opportunity";
    JSErrorsMetricNames["MultiClicks"] = "errors-with-multiple-clicks";
})(JSErrorsMetricNames || (JSErrorsMetricNames = {}));
export var JSErrorsSorting;
(function (JSErrorsSorting) {
    JSErrorsSorting["ASC"] = "ASC";
    JSErrorsSorting["DESC"] = "DESC";
})(JSErrorsSorting || (JSErrorsSorting = {}));
export var JSErrorsErrorTypes;
(function (JSErrorsErrorTypes) {
    JSErrorsErrorTypes["JS"] = "JS";
    JSErrorsErrorTypes["API"] = "API";
    JSErrorsErrorTypes["CUSTOM"] = "CUSTOM";
})(JSErrorsErrorTypes || (JSErrorsErrorTypes = {}));
export var JSErrorsGroupingType;
(function (JSErrorsGroupingType) {
    JSErrorsGroupingType["ERROR_ATTRIBUTES"] = "ERROR_ATTRIBUTES";
    JSErrorsGroupingType["REGEX_FINGERPRINT"] = "REGEX_FINGERPRINT";
})(JSErrorsGroupingType || (JSErrorsGroupingType = {}));
export var JSErrorsAggregationMethod;
(function (JSErrorsAggregationMethod) {
    JSErrorsAggregationMethod["AVERAGE"] = "AVERAGE";
    JSErrorsAggregationMethod["MEDIAN"] = "MEDIAN";
})(JSErrorsAggregationMethod || (JSErrorsAggregationMethod = {}));
export var JSErrorsStatuses;
(function (JSErrorsStatuses) {
    JSErrorsStatuses["UndismissedErrors"] = "UNDISMISSED";
    JSErrorsStatuses["DismissedErrors"] = "DISMISSED";
    JSErrorsStatuses["All"] = "ALL";
})(JSErrorsStatuses || (JSErrorsStatuses = {}));
export var JiraStatuses;
(function (JiraStatuses) {
    JiraStatuses["SentToJira"] = "SENT_TO_JIRA";
})(JiraStatuses || (JiraStatuses = {}));
//# sourceMappingURL=js-errors.enums.js.map